module.exports = __webpack_public_path__ + "static/media/win-reward-A11.7b570f82.png";